<template>
  <div>
    <v-layout wrap>
      <v-flex xs8>
        <h3 class="headline">{{ $t('setting_chat_notification') }}</h3></v-flex
      >
      <v-flex xs4 class="justify-end align-center" style="display: flex">
        <v-btn fab small color="primary" outline class="mx-1 my-0" @click="isEditing = true">
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <div class="mb-4">
      <div class="pb-2">1.แสดงแถบสีเมื่อมี chat จากลูกค้าเข้ามา</div>
      <div v-if="isEditing">
        <swatches v-model="admin_unread_color" show-fallback fallback-input-type="color"></swatches>
      </div>
      <template v-else>
        <div
          style="width: 42px; height: 42px; border: 1px solid #ccc; border-radius: 8px"
          :style="`background-color: ${admin_unread_color}`"
        ></div>
      </template>
    </div>
    <div>
      <div class="pb-2">2.แสดงแถบสี เมื่อแอดมินกดอ่านแชทของลูกค้าแล้ว</div>
      <div v-if="isEditing">
        <swatches v-model="admin_read_color" show-fallback fallback-input-type="color"></swatches>
      </div>
      <template v-else>
        <div
          style="width: 42px; height: 42px; border: 1px solid #ccc; border-radius: 8px"
          :style="`background-color: ${admin_read_color}`"
        ></div>
      </template>
    </div>
    <div v-if="isEditing">
      <div class="text-xs-center">
        <v-btn outline color="grey" @click="handleCancel">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="handleSave">{{ $t('Save') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import chatlogApi from '@/api/chatlog'
import { mapGetters } from 'vuex'
import { handleResponse, handleApiError } from '@/api/util'
import Swatches from 'vue-swatches'
export default {
  components: {
    Swatches
  },
  data() {
    return {
      isEditing: false,
      admin_read_color: '',
      admin_unread_color: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    chatConfig() {
      return this.$store.state.chatConfig
    }
  },
  watch: {
    chatConfig: {
      immediate: true,
      handler() {
        if (this.chatConfig) {
          this.admin_read_color = this.chatConfig.admin_read
          this.admin_unread_color = this.chatConfig.admin_unread
        }
      }
    }
  },
  mounted() {
    if (!this.chatConfig) {
      this.$store.dispatch('getChatConfig')
    }
  },
  methods: {
    async handleSave() {
      const vm = this
      try {
        const data = {
          page_id: vm.selectedBot.pageid,
          config: {
            admin_read: vm.admin_read_color,
            admin_unread: vm.admin_unread_color
          }
        }

        vm.$store.dispatch('loading')
        const response = await chatlogApi.postUpdateConfigReadChatColor({
          data
        })
        vm.$store.commit('CLEAR_LOADING')
        handleResponse(response)

        if (response && response.status === 200) {
          await vm.$swal.fire({
            type: 'success',
            text: 'สำเร็จ'
          })
          vm.handleCancel()
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        vm.$store.commit('CLEAR_LOADING')
      }
    },
    handleCancel() {
      this.isEditing = false
      this.$store.dispatch('getChatConfig')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/ChatNotificationSetting.vue